export const compareArrays = (current: string[], updated: string[]) => {
    return (current.length === updated.length) &&
            (current.every((id: string) => updated.indexOf(id) > -1));
}